/**
 * Single source of truth for the studio's "gated" (production) configuration.
 *
 * When gated:
 *  - login is required (see App.vue / client.ts),
 *  - the advanced editors — Battle Tactics, Armies, Regiments of Renown — are
 *    hidden from the activity rail (see surfaces/index.ts),
 *  - new bundles are locked to the Core battlepack (see StudioBar.vue).
 *
 * Active in any production build. Can be forced on under `pnpm dev` with
 * VITE_STUDIO_GATED=1 (the `dev:gated` script) to exercise the gated
 * experience locally — the client keeps its localhost API/redirect URLs
 * because it still sees `import.meta.env.DEV`.
 */
const forceGated =
  import.meta.env.VITE_STUDIO_GATED === '1' || import.meta.env.VITE_STUDIO_GATED === 'true';

export const isGated = !import.meta.env.DEV || forceGated;
